import React from 'react';

const STATE_CONFIGS = {
  unattuned: {
    color: 'rgba(255, 255, 255, 0.3)',
    glow: 'none',
    animationClass: ''
  },
  slowing: {
    color: '#4a6fa5',
    glow: '0 0 10px rgba(74, 111, 165, 0.4)',
    animationClass: 'field-pulse-slow'
  },
  listening: {
    color: '#4a6fa5',
    glow: '0 0 15px rgba(74, 111, 165, 0.6)',
    animationClass: 'field-pulse-medium'
  },
  triadic_open: {
    color: '#2a9d8f',
    glow: '0 0 20px rgba(42, 157, 143, 0.6)',
    animationClass: 'field-pulse-fast'
  },
  immersed: {
    color: '#b76e79',
    glow: '0 0 25px rgba(183, 110, 121, 0.7)',
    animationClass: 'field-pulse-fastest'
  }
};

export default function FieldStateIndicator({ state = 'unattuned', size = 'small' }) {
  const config = STATE_CONFIGS[state] || STATE_CONFIGS.unattuned;
  
  const sizes = {
    tiny: 'w-2 h-2',
    small: 'w-3 h-3',
    medium: 'w-4 h-4',
    large: 'w-6 h-6'
  };
  
  return (
    <div
      className={`rounded-full ${sizes[size]} ${config.animationClass}`}
      style={{
        backgroundColor: config.color,
        boxShadow: config.glow
      }}
    />
  );
}
